<template>
  <el-dialog
    width="500px"
    modal-append-to-body
    append-to-body
    custom-class="dialog_box"
    title="权限管理(品牌关键词数据)"
    :visible.sync="visible"
    :before-close="beforeClose"
  >
    <el-form
      ref="companyJust"
      :model="formData"
      :rules="formRules"
      size="small"
      label-position="right"
      label-width="150px"
      label-suffix=":"
    >
      <el-form-item label="品牌数量" prop="brandNum">
        <el-input v-model="formData.brandNum"></el-input>
      </el-form-item>
      <el-form-item label="每个品牌关键词数量" prop="keywordNum">
        <el-input v-model="formData.keywordNum"></el-input>
      </el-form-item>
    </el-form>
    <div class="form_footer">
      <el-button size="small" @click="beforeClose">取消</el-button>
      <el-button size="small" type="primary" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import formRules from "./rules";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    initFormData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: {
        brandNum: "",
        keywordNum: "",
      },
      formRules: {
        brandNum: [
          {
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!this.formData.brandNum && !this.formData.keywordNum) {
                callback(new Error("品牌数量或关键词数量必填其中一个"));
              }
              if (!this.formData.keywordNum) {
                const pattern = /^[1-9]\d*$/;
                if (!pattern.test(value)) {
                  callback(new Error("品牌数量必须为正整数"));
                }
              }
              callback();
            },
          },
        ],
        keywordNum: [
          {
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!this.formData.brandNum && !this.formData.keywordNum) {
                callback(new Error("必填品牌数量或关键词数量其中一个"));
              }
              if (!this.formData.brandNum) {
                const pattern = /^[1-9]\d*$/;
                if (!pattern.test(value)) {
                  callback(new Error("品牌数量必须为正整数"));
                }
              }
              callback();
            },
          },
        ],
      },
      updatePwd: false,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.initData();
      }
    },
  },
  methods: {
    initData() {
      // this.formData = { ...this.initFormData };
      this.$http({
        url: "/permission/findByOne",
        params: {
          enterpriseId: this.initFormData.enterpriseId,
        },
        method: "get",
      })
        .then((res) => {
          if (res.code === 200) {
            this.formData = {
              brandNum: res.data.brandNum,
              keywordNum: res.data.keywordNum,
              permissionId: res.data.permissionId,
              enterpriseId: res.data.enterpriseId,
            };
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch(() => {
          this.$message({
            message: "获取企业权限设置失败",
            type: "error",
          });
        });
    },
    submit() {
      this.$refs.companyJust
        .validate()
        .then(() => {
          if (this.formData.brandNum)
            this.formData.brandNum = Number(this.formData.brandNum);
          if (this.formData.keywordNum)
            this.formData.keywordNum = Number(this.formData.keywordNum);
          const url = "/permission/update";
          this.$http({
            url,
            method: "post",
            data: this.formData,
          }).then((res) => {
            if (res.code === 200) {
              const message = "权限管理编辑成功";
              this.$message({
                message,
                type: "success",
              });
              this.beforeClose();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch((err) => {
          console.log("表单校验失败");
        });
    },
    // 关闭前的回调
    beforeClose() {
      this.updatePwd = false;
      this.formData = {
        brandNum: 1,
        keywordNum: 1,
      };
      this.$emit("update");
      this.$emit("close-modal");
      this.$refs.companyJust.resetFields();
    },
  },
};
</script>

<style lang="scss">
.dialog_box {
  border-radius: 10px;
}
.form_footer {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/companyManage/companyJust.vue